import { encode } from '../helpers/general.helpers'

const abstractCartCostings = (cost) => ({
  totalCost: cost.totalAmount.amount || 0,
  currencyCode: cost.totalAmount.currencyCode || null,
})

const mapCartLineItems = (lines) => {
  if (!lines || !lines.edges || lines.edges.length === 0) return []

  return lines.edges.reduce((allLineItems, { node: line }) => {
    const { id, quantity, merchandise, attributes } = line

    if (!id || !quantity || !merchandise) return allLineItems

    return [
      ...allLineItems,
      {
        id: id ? encode(id) : null,
        quantity: quantity || 0,
        title: merchandise.title || '',
        customAttributes: attributes || [],
        discountAllocations: [],
        variant: {
          id: merchandise.id ? encode(merchandise.id) : null,
          title: merchandise.title,
          price: merchandise.priceV2 ? merchandise.priceV2.amount : null,
          sku: merchandise.sku,
          compareAtPrice: merchandise.compareAtPriceV2
            ? merchandise.compareAtPriceV2.amount
            : null,
          image: merchandise.image,
          selectedOptions: merchandise.selectedOptions,
          product: merchandise.product,
        },
      },
    ]
  }, [])
}

export const mapCartForStorefront = (shopifyCart) => {
  const {
    id,
    checkoutUrl,
    totalQuantity,
    discountAllocations,
    discountCodes,
    note,
    attributes,
    cost,
    lines,
  } = shopifyCart

  const { currencyCode, totalCost } = abstractCartCostings(cost)

  return {
    id: id ? encode(id) : null,
    quantity: totalQuantity || 0,
    customAttributes: attributes,
    webUrl: checkoutUrl || null,
    note: note || '',
    currencyCode: currencyCode || null,
    totalPrice: totalCost || 0,
    discountApplications: discountAllocations || [],
    discountCodes: discountCodes || [],
    lineItems: mapCartLineItems(lines) || [],
  }
}

export const mapCartLineItemsForShopifyAdd = (lineItems) => {
  return lineItems.map((lineItem) => {
    const hasSellingPlan = !!lineItem.sellingPlanId

    return {
      merchandiseId: lineItem.variantId,
      quantity: lineItem.quantity,
      sellingPlanId: lineItem.sellingPlanId || null,
      attributes: lineItem.customAttributes,
    }
  })
}

export const mapCartLineItemsForShopifyUpdate = (lineItems) => {
  const financialReportingCustomAttribute = {
    key: LINE_ITEM_ATTR_REPORTING_ITEM_PURCHASE_TYPE,
    value: 'non-subscription',
  }

  return lineItems.map((lineItem) => ({
    id: lineItem.id,
    quantity: lineItem.quantity,
    attributes:
      lineItem.customAttributes && lineItem.customAttributes.length
        ? lineItem.customAttributes
        : [],
  }))
}
